import React, { useContext, useState, useEffect } from 'react';
import './PlaylistHeader.css';
import { DataContext } from "../DataContexts/DataContext";
import CuratorPage from './CuratorPage';
import MediaStudioPage from './MediaStudioPage';
import Blocklists from '../MachineManager/Blocklists';
import { useSearchParams } from 'react-router-dom';

const TAB_KEYS = ['curator', 'mediastudio', 'blocklists'];

const PlaylistHeader = () => {
  const { loading, error } = useContext(DataContext);
  const [activeTab, setActiveTab] = useState('curator');
  const [searchParams, setSearchParams] = useSearchParams();

  // Deep links: an explicit ?tab= wins (also what keeps a refresh on the
  // right sub-tab, DJB-80), then playlist/playtree ids land on the merged
  // Curator tab (which expands the right accordion section itself), ad ids
  // on Media Studio and blocklist ids on Assign.
  useEffect(() => {
    const tab = searchParams.get('tab');
    const playlistId = searchParams.get('playlistId');
    const playtreeId = searchParams.get('playtreeId');
    const blocklistId = searchParams.get('blocklistId');
    const adId = searchParams.get('adId');

    if (TAB_KEYS.includes(tab)) {
      setActiveTab(tab);
    } else if (playlistId || playtreeId) {
      setActiveTab('curator');
    } else if (adId) {
      setActiveTab('mediastudio');
    } else if (blocklistId) {
      setActiveTab('blocklists');
    }
  }, [searchParams]);

  // Switching tabs records the choice in the URL so a refresh or shared link
  // stays on the same sub-tab. Any id deep-link params stay untouched: the
  // explicit tab param outranks them in the effect above.
  const openTab = (tab) => {
    setActiveTab(tab);
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.set('tab', tab);
        return next;
      },
      { replace: true }
    );
  };

  if (loading) {
    return (
      <div>
        <h1>Playlist manager</h1>
        <p>Loading data, please wait... 🎵</p>
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <h1>Playlist manager</h1>
        <p>Error loading data: {error}</p>
      </div>
    );
  }

  return (
    <div className="playlist-navigator-header">
      <div className="tab-container">
        <button
          className={`tab ${activeTab === 'curator' ? 'active' : ''}`}
          onClick={() => openTab('curator')}
        >
          Playlist Studio
        </button>
        <button
          className={`tab ${activeTab === 'mediastudio' ? 'active' : ''}`}
          onClick={() => openTab('mediastudio')}
        >
          Media Studio
        </button>
        {/* Renamed from "Access Control" (DJB-82); the 'blocklists' key and
            ?blocklistId deep link stay as-is so existing links keep working */}
        <button
          className={`tab ${activeTab === 'blocklists' ? 'active' : ''}`}
          onClick={() => openTab('blocklists')}
        >
          Subscriptions &amp; Restrictions
        </button>
      </div>
      <div className="tab-content">
        {activeTab === 'curator' && (
          <div>
            <CuratorPage />
          </div>
        )}
        {activeTab === 'mediastudio' && (
          <div>
            <MediaStudioPage />
          </div>
        )}
        {activeTab === 'blocklists' && (
          <div>
            <Blocklists />
          </div>
        )}
      </div>
    </div>
  );
};

export default PlaylistHeader;
